export default __webpack_public_path__ + "static/media/MemberTabDEActive.b24424e0.svg";